import EventActionProto from '../../event-action-proto'
import SessionReminderModel from "../session-reminder-model"

module.exports = class SessionReminderNew extends EventActionProto {

    constructor(uid, data, sid, companyId, sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            reminder    : sessionEvent.data,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        // never initialized
        if (!gd.session.reminders) {
            // ignore
        } else {
            const reminder = new SessionReminderModel(this.data)
            gd.session.reminders.add(reminder.id, reminder, true)
            gd.modelBus.newUpdate('reminder', this.method, this.header.reminder.id, this.data, this.header)
        }

        super.process()
    }
}